import { Search } from 'lucide-react';
import { cn } from '@/lib/utils';

/** Search input with the magnifier of the mock-ups (07, 10, 11, 14). */
export function SearchField({
  label,
  placeholder,
  value,
  onChange,
  className,
}: {
  label: string;
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
  className?: string;
}) {
  return (
    <label className={cn('relative flex flex-[1_1_220px] items-center', className)}>
      <span className="sr-only">{label}</span>
      <Search aria-hidden="true" className="pointer-events-none absolute left-3 size-4 text-muted-foreground" />
      <input
        type="search"
        value={value}
        placeholder={placeholder}
        onChange={(event) => onChange(event.target.value)}
        className="box-border min-h-10 w-full rounded-control border border-input bg-card pl-9 pr-3 font-[inherit] text-sm text-foreground"
      />
    </label>
  );
}
